import { useStore } from '../../../app/stores/store';
import { Icon, Segment, Step } from 'semantic-ui-react';
import {
  HFCorderL2Options,
  orderL2Options,
  ordersIncomingOptions,
  HFCordersIncomingOptions,
  ordersOutcomingOptions,
  ordersReportOptions,
  HFCreceivingOption,
  HFCServiceOption,
} from '../../../app/common/options/dashboardOptions/stepOrderOptions';
import StepL3ForOrders from './StepL3ForOrders';

function StepL2ForOrders() {
  const { dashboardStore, commonStore } = useStore();
  const dsorders = dashboardStore.dashboard.L2CardValueOrders;
  const L20options = commonStore.hfcCustomerChanges ? HFCorderL2Options: orderL2Options
  return (
    <Segment>
      <Step.Group size="tiny" widths={7}>
        {L20options.map((a: any) =>
          commonStore.filterModeTwo.includes(a.id) ? (
            <></>
          ) : (
            <Step
              className={
                dashboardStore.dashboard.L2CardValueOrders === a.value
                  ? 'orderlevel2dark'
                  : 'orderlevel2light'
              }
              style={{
                borderRight: '1px solid #F0F0F0',
                background: `linear-gradient(90deg, rgba(215,235,242,1) ${
                  a.gradientvalue
                }%, rgba(255,255,255,1)${a.gradientvalue + 10}% )`,
              }}
              onClick={() => dashboardStore.openL2ForOrders(a.value)}
              disabled={commonStore.filterModeZero.includes(`${a.id}`)}
            >
              <Icon name={a.Icon} />

              <Step.Content>
                <Step.Title>{a.text} </Step.Title>
              </Step.Content>
            </Step>
          ),
        )}
      </Step.Group>

      {dsorders === 'Reports' ? (
        <StepL3ForOrders options={ordersReportOptions} />
      ) : dsorders === 'Outward' ? (
        <StepL3ForOrders options={ordersIncomingOptions} />
      ) : dsorders === 'Inward' ? (
        <StepL3ForOrders options={ordersOutcomingOptions} />
      ) : dsorders === 'Shipping' ? (
        <StepL3ForOrders options={HFCordersIncomingOptions} />
      ):  dsorders === 'Receiving' ? (
        <StepL3ForOrders options={HFCreceivingOption} />
      ) : dsorders === 'Service Requests' ? (
        <StepL3ForOrders options={HFCServiceOption} />
      ) : null}
    </Segment>
  );
}

export default StepL2ForOrders;
